// Firebase App (the core Firebase SDK) is always required and must be listed first
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import "firebase/firestore";
import "firebase/functions";
import "firebase/storage";
import * as firebaseui from "firebaseui";

require("firebase/analytics");

// For Firebase JavaScript SDK v7.20.0 and later, `measurementId` is an optional field
const firebaseConfig = {
    apiKey: process.env.FIREBASE_API_KEY,
    authDomain: process.env.FIREBASE_AUTH_DOMAIN,
    projectId: process.env.FIREBASE_PROJECT_ID,
    storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.FIREBASE_APP_ID,
    databaseURL: process.env.FIREBASE_REALTIME_DATABASE_URL,
    measurementId: process.env.FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
    firebase.firestore().settings({ ignoreUndefinedProperties: true });
} else {
    firebase.app(); // if already initialized, use that one
}

const analytics = firebase.analytics();
const db = firebase.database();
const firestore = firebase.firestore();

const auth = firebase.auth();
const functions = firebase.functions();
const storage = firebase.storage();
if (location.hostname === "localhost") {
    console.log("USING Functions EMULATOR");
    firebase.functions().useEmulator("localhost", 5001);

    // Only use the Auth and Realtime Database emulators if the local start script indicated so.
    if (process.env.USE_EMULATORS === "true") {
        console.log("USING Auth, Realtime Database, Firestore, Storage EMULATORS: " + process.env.USE_EMULATORS);
        firestore.useEmulator("localhost", 8080);
        db.useEmulator("localhost", 9000);
        auth.useEmulator("http://localhost:9099");
        storage.useEmulator("localhost", 9199);
    } else {
        console.log("NOT USING Auth, Realtime Database, Firestore, Storage EMULATORS: " + process.env.USE_EMULATORS);
    }
}

export { firebase, firebaseui, auth, db, firestore, functions, analytics, storage };
